import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';

export default function VerifyEmail() {
    const { token } = useParams();
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const verifyObj = async () => {
            try {
                const API_BASE = process.env.REACT_APP_API_URL || '';
                const res = await fetch(`${API_BASE}/api/auth/verify/${token}`);
                const data = await res.json();

                if (!res.ok) {
                    throw new Error(data.error || 'שגיאה באימות אימייל');
                }
                setMessage(data.message);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        verifyObj();
    }, [token]);

    return (
        <div className="min-h-screen flex text-center items-center justify-center bg-slate-50 p-4" dir="rtl">
            <div className="max-w-md w-full bg-white rounded-3xl shadow-xl border border-slate-100 p-8">
                {loading ? (
                    <div className="text-xl font-bold text-slate-600">מאמת אותך מול השרת...</div>
                ) : error ? (
                    <div>
                        <div className="bg-red-50 text-red-600 p-4 rounded-xl font-bold mb-6 border border-red-100">{error}</div>
                        <Link to="/" className="text-blue-600 font-bold hover:underline">חזרה לדף הבית</Link>
                    </div>
                ) : (
                    <div>
                        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-100 text-green-600 mb-6">
                            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path></svg>
                        </div>
                        <h2 className="text-2xl font-black text-slate-900 mb-2">אימייל אומת בהצלחה!</h2>
                        <p className="text-slate-600 mb-8">{message}</p>
                        <Link to="/login" className="bg-blue-600 hover:bg-blue-700 text-white font-black py-3 px-6 rounded-xl transition-all shadow-md">
                            מעבר למסך ההתחברות
                        </Link>
                    </div>
                )}
            </div>
        </div>
    );
}
